export default class CalendarMonth {
  constructor(weeks, events, displayDay) {
    this.weeks = weeks;
    this.events = events;
    this.displayDay = displayDay;
  }
}
